/**
 * @generated SignedSource<<c7b6cc765d8c624ebfa925b5fc1d9282>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_servicedeskSettingsVirtualAgentLanding_VirtualAgentLanding_projectRef$data = {
  readonly " $fragmentSpreads": FragmentRefs<"main_servicedeskSettingsVirtualAgentLanding_LandingPage_projectRef">;
  readonly " $fragmentType": "ui_servicedeskSettingsVirtualAgentLanding_VirtualAgentLanding_projectRef";
};
export type ui_servicedeskSettingsVirtualAgentLanding_VirtualAgentLanding_projectRef$key = {
  readonly " $data"?: ui_servicedeskSettingsVirtualAgentLanding_VirtualAgentLanding_projectRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_servicedeskSettingsVirtualAgentLanding_VirtualAgentLanding_projectRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ui_servicedeskSettingsVirtualAgentLanding_VirtualAgentLanding_projectRef",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "main_servicedeskSettingsVirtualAgentLanding_LandingPage_projectRef"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "fde2f2a3e3ef9e3549e94191b8577bba";

export default node;
